export default {
    title: "DXC Engrenagem",
    support: "Apoiar",
    dashboard: "Painel"
}